module.exports = __webpack_public_path__ + "static/media/graphic-element-bottom.5f1a0418.svg";